<template>
    <v-tooltip top>
        <a slot="activator" @click="inativarAnexo" class="az-action-link-icon">
            <i :class="classeIcone" aria-hidden="true"/>
        </a>
        <span v-if="bloquearAcao === true">Aguarde</span>
        <span v-else>Inativar</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'BotaoInativarAnexo',
    props:{
        situacaoAtual:{
            type: String,
            default: null
        }
    },
    data(){
        return{
            bloquearAcao: false
        }
    },
    computed:{
        classeIcone(){
            const base = 'fas fa-eye-slash'
            if(this.bloquearAcao === true){
                return base + ' ' + 'desativado'
            }
            return base
        }
    },
    methods:{
        inativarAnexo(){
            if(this.bloquearAcao === true){ return }
            this.$emit('inativarAnexo')
        },
        desabilitarTemporario(){
            this.bloquearAcao = true

            setTimeout(() => {
                this.bloquearAcao = false
            }, 10000)
        }
    },
    watch:{
        situacaoAtual:{
            handler(){
                this.desabilitarTemporario()
            }
        }
    }
}

</script>

<style scoped lang="stylus">
    @media (max-width 720px)
        .az-action-link-icon i
            font-size 20px

    .desativado
        opacity 0.5
</style>
